import { useState } from 'react';
import PresupuestoModal from '../../../components/base/PresupuestoModal';

const CtaSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="bg-navy py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block bg-orange text-white text-sm font-medium px-4 py-2 rounded-full mb-5">
            Presupuesto sin compromiso
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5 max-w-3xl mx-auto">
            ¿Necesitas vaciar un piso o local en Barcelona?
          </h2>
          <p className="text-lg text-white/85 leading-relaxed mb-10 max-w-2xl mx-auto">
            Contacta con nosotros y te daremos un presupuesto personalizado en menos de 24 horas. Sin letra pequeña, sin sorpresas.
          </p>

          <div className="inline-flex items-center gap-3 bg-orange/20 border-2 border-orange text-white px-6 py-3 rounded-full mb-8">
            <i className="ri-information-line text-xl"></i>
            <span className="font-bold text-sm">NO RECOGEMOS MUEBLES SUELTOS</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-orange text-white text-base font-medium px-8 py-4 rounded-full hover:bg-orange-light hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl mr-2"></i>
              Enviar fotos por WhatsApp
            </a>
            <button
              onClick={() => setShowModal(true)}
              className="inline-flex items-center justify-center border-2 border-white bg-transparent text-white text-base font-medium px-8 py-4 rounded-full hover:bg-white hover:text-navy transition-all whitespace-nowrap cursor-pointer"
            >
              Solicitar presupuesto
            </button>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-lg"></i>
              <a href="tel:+34629501941" className="hover:text-orange transition-colors cursor-pointer">
                +34 629 501 941
              </a>
            </div>
            <div className="hidden sm:block w-px h-4 bg-white/30"></div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-lg"></i>
              <a
                href="mailto:info@barcelona.biotrauma.es"
                className="hover:text-orange transition-colors cursor-pointer"
              >
                info@barcelona.biotrauma.es
              </a>
            </div>
          </div>
        </div>
      </section>

      <PresupuestoModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default CtaSection;
